import value from './value.js'
import units from './units.js'
import change from './change.js'
import * as d3 from 'd3-selection'
import explanation from './explanation.js'

const padding = {
  top: 6.5,
  bottom: 0
}

export default function (id, dimensions) {
  let draw = function (selection) {
    selection.each(function (data) {
      let header = d3.select(this)
                     .selectAll('g.header-row').data([data])
        , _header = header.enter()
                          .append('g')
                            .attr('class', 'header-row')
                            .merge(header)

      _header.attr('transform', 'translate(' + 0 + ',' + (dimensions.viewbox.height + padding.top) + ')')
             .call(explanation(dimensions))
             .call(value(id, dimensions))
             .call(change(id, dimensions))
             .call(units(dimensions))

      // Increase the overall height if the header has elements
      if (_header.selectAll('*').size()) {
        dimensions.viewbox.height += padding.top + dimensions.header.height + padding.bottom
      }
    })
  }

  return draw

}
